import { render, staticRenderFns } from "./manage-videos.vue?vue&type=template&id=01c756b6&scoped=true&"
import script from "./manage-videos.vue?vue&type=script&lang=js&"
export * from "./manage-videos.vue?vue&type=script&lang=js&"
import style0 from "./manage-videos.vue?vue&type=style&index=0&id=01c756b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c756b6",
  null
  
)

export default component.exports